// A read that failed: say why in the words for the server's problem code, quote the request id (the trace id,
// spec/08 §2.11) when the answer is a generic one, offer a retry where trying again can help.

import { useTranslation } from '@clavian/i18n/react';
import { Button } from '@clavian/ui-web';

import { useProblem } from '../api/use-problem';

export function LoadFailure({ error, message, onRetry }: { readonly error: unknown; readonly message?: string; readonly onRetry?: () => void }) {
  const { t } = useTranslation('console');
  const problem = useProblem();
  // The screen's own line (`message`) is the fallback for a code with no copy; a code with copy says that instead.
  const view = problem.view(error, message === undefined ? {} : { fallback: message });
  return (
    <div className="console-alert" role="alert">
      <p>{view.message}</p>
      {view.reference ? <p className="console-muted">{t('errors.reference', { id: view.reference })}</p> : null}
      {onRetry && (view.retryable || view.specific === false) ? (
        <Button size="sm" onClick={onRetry}>
          {t('errors.retry')}
        </Button>
      ) : null}
    </div>
  );
}
